var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content-page" },
    [
      _c("cms-partial-data-provider", {
        attrs: { name: "error_404" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(props) {
              return _c(
                "cms-generic-placeholder",
                _vm._b(
                  { staticClass: "not-found--content-placeholder" },
                  "cms-generic-placeholder",
                  props,
                  false
                )
              )
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a0b31c2", { render: render, staticRenderFns: staticRenderFns })
  }
}